var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }